import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  color: {
    rental: 'geekblue',
    lesson: 'cyan',
    package: 'purple',
    voucher: 'green',
    item: 'volcano',
    scheduled: 'blue',
    canceled: 'red',
    finished: 'green',
    inProgress: 'cyan',
    open: 'purple',
    number: {
      positive: '#3f8600',
      negative: 'rgb(207, 19, 34)',
    },
    text: {
      light: 'rgba(0, 0, 0, 0.45)',
      danger: '#f5222d',
      hover: '#40a9ff',
      success: '#52c41a',
      link: '#268eb3',
      default: '#797979',
    },
    border: {
      default: '#F0F0F0',
      hover: '#40a9ff',
      primary: '#91D3FF',
      bold: '#d9d9d9',
    },
    background: {
      green: '#f0faeb',
      red: '#f5ebfa',
    },
    lightGray: '#fafafa',
    lightGray2: '#f7f7f7',
    lightGray3: '#f0f0f0',
    gray: '#797979',
    white: '#fff',
  },
  event: {
    scheduled: {
      backgroundColor: '#e6f7ff',
      borderColor: '#91d5ff',
      color: '#1890ff',
      dark: {
        backgroundColor: '#c9e9f9',
      },
    },
    inProgress: {
      backgroundColor: '#fff7e6',
      borderColor: '#ffd591',
      color: '#fa8c16',
      dark: {
        backgroundColor: '#ffedc7',
      },
    },
    finished: {
      backgroundColor: '#f6ffed',
      borderColor: '#b7eb8f',
      color: '#52c41a',
      dark: {
        backgroundColor: '#e0ffd2',
      },
    },
    canceled: {
      backgroundColor: '#fff1f0',
      color: '#ff4d4f',
      dark: {
        backgroundColor: '#e6f7ff',
      },
    },
    unassigned: {
      backgroundColor: '#DCDCDC',
      borderColor: '#C0C0C0',
      color: '#333333',
      dark: {
        backgroundColor: '#CCC',
      },
    },
    pending: {
      backgroundColor: '#f9f0ff',
      borderColor: '#d3adf7',
      color: '#531dab',
      dark: {
        backgroundColor: '#c589ed',
      },
    },
  },
  size: {
    borderRadius: 6,
    iconPrefix: 40,
    header: 64,
    drawerCollapsed: 80,
    drawer: 200,
    layout: 900,
  },
  media: {
    mobile: 576,
  },
  spacing: {
    xs: 6,
    small: 10,
    default: 20,
    large: 40,
  },
};

export default theme;
